
<template>
	<page>
		<module>
            <view-list
                    ref="view"
                    work-type="40"
                    selector
            >
				<template #search>
					<m-search ref="search">
						<m-search-item label="场次">
							<c-input name="auction_batch_no"></c-input>
						</m-search-item>
						<m-search-item label="报告时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<!-- 推送渠道列：渠道名(成功/失败/总数)，成功绿色失败红色 -->
				<template #channel_summary_json="{data}">
					<span v-for="(item, index) in parseSummary(data.channel_summary_json)" :key="index" class="m-channel-item">
						<span>{{item.channel_name}}(</span><span style="color: #19be6b;">{{item.success}}</span><span style="color: #ed3f14;">/{{item.fail}}</span><span>/{{item.total}})</span>
					</span>
					<span v-if="!parseSummary(data.channel_summary_json).length">-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="100"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="viewDetail(data)">详情</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!-- 推送报告详情 -->
			<auction-push-report-detail ref="detail"></auction-push-report-detail>
		</module>
	</page>
</template>

<script>
	import AuctionPushReportDetail from './auction_push_report_detail';

	export default {
		components: {
			AuctionPushReportDetail
		},

		methods: {
			/*********解析渠道汇总JSON**********/
			parseSummary(json) {
				try {
					var list = JSON.parse(json || '[]');
					return Array.isArray(list) ? list : [];
				} catch (e) {
					return [];
				}
			},

			/*********查看推送报告详情**********/
			viewDetail(data) {
				this.$refs.detail.open({
					id: data.id
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel-item {
		display: inline-block;
		margin-right: 8px;
	}
</style>
